/**
 * The page's entry. Start the game in the one stage on the page, and give the
 * native menu a way in: every menu item is a `data-act` the page already has
 * a button for, so the menu clicks the button on whichever screen is up.
 */

import { runTank } from "../game/game.ts";

const root = document.querySelector<HTMLElement>("[data-tank]");
if (!root) throw new Error("Paper Tanks: no [data-tank] on the page");

// A way in from a URL, for screenshots and for poking at a screen without a
// mouse: `?camera=heading&act=play` or `?act=mods`. Harmless in the app.
const query = new URLSearchParams(location.search);
const camera = query.get("camera");
if (camera === "heading" || camera === "north") localStorage.setItem("paper-tank.camera", camera);

// Inside the desktop app the runtime exposes `bindings`; on a plain web page
// there is none, and the page gets the browser's own full-screen button.
const desktop = "bindings" in globalThis;
if (desktop) document.documentElement.dataset.desktop = "";

const reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;
runTank(root, { reduced, desktop });

const act = (id: string): boolean => {
  // The game hides whole screens, never single buttons, so the visible
  // button is the one with no hidden ancestor. If there is none, the action
  // is not on offer right now and the menu does nothing, which is right:
  // "Restart level" on the title screen should not start a level.
  // Sound is the exception: mute should work from any screen, so it falls
  // back to the switch on the settings sheet even while that is hidden.
  const buttons = [...root.querySelectorAll<HTMLButtonElement>(`[data-act="${id}"]`)];
  const visible = buttons.find((b) => b.closest("[hidden]") === null) ?? (id === "sound" ? buttons[0] : undefined);
  visible?.click();
  return Boolean(visible);
};

declare global {
  var paperTank: { act: (id: string) => boolean };
}
globalThis.paperTank = { act };

for (const id of query.getAll("act")) act(id);
